import { Tooltip, TooltipProps } from '@mui/material'
import { getDurationString } from '../../store/utils/worklogUtils'

type Props = {
  hours: number
} & Omit<TooltipProps, 'title'>

const DecimalHourDurationTooltip = ({ hours, ...props }: Props) => {
  const title = Number.isInteger(hours) ? '' : getDurationString(hours)
  return <Tooltip {...props} title={title} />
}

export default DecimalHourDurationTooltip
